import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  unitsCounter: {
    display: 'flex',
    alignContent: 'center',
    marginTop: '24px',
    '& .MuiButton-actionIcon': {
      padding: '12px',
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px'
      }
    }
  },
  disabledUnitsCounterInput: {
    pointerEvents: 'none'
  },
  unitsCounterInput: {
    width: '120px',
    margin: '0 10px'
  },
  unitsCounterInputWithoutControllers: {
    margin: '0 10px 0 0'
  }
});
export default useStyles;